const MAX_VISIBLE_DOTS = 7;
const DOT_SIZE = 6;
const DOT_GAP = 7;
const DOT_STEP = DOT_SIZE + DOT_GAP;
const DOT_SCALE_PADDING = 3;

export function GalleryDots({ count, selectedIndex }: { count: number; selectedIndex: number }) {
  const visibleCount = Math.min(count, MAX_VISIBLE_DOTS);
  const activeIndex = Math.max(0, Math.min(selectedIndex, count - 1));
  const centeredStart = activeIndex - Math.floor(visibleCount / 2);
  const startIndex = Math.max(0, Math.min(centeredStart, count - visibleCount));
  const endIndex = startIndex + visibleCount - 1;

  if (visibleCount === 0) return null;

  return (
    <View
      className={'h-2.5 overflow-hidden'}
      style={{
        paddingHorizontal: DOT_SCALE_PADDING,
        width: visibleCount * DOT_SIZE + (visibleCount - 1) * DOT_GAP + DOT_SCALE_PADDING * 2,
      }}
      testID={'gallery-dots'}
    >
      <View
        className={'flex h-2.5 items-center transition-transform duration-200 ease-out'}
        style={{
          columnGap: DOT_GAP,
          flexDirection: 'row',
          transform: [{ translateX: -startIndex * DOT_STEP }],
        }}
        testID={'gallery-dots-track'}
      >
        {Array.from({ length: count }, (_, index) => {
          const isActive = activeIndex === index;
          const size = getDotSize(index, startIndex, endIndex, count);
          const scale = size === 'large' ? 1.4 : size === 'medium' ? 1.1 : 0.8;
          const opacity = isActive ? 1 : size === 'large' ? 0.65 : size === 'medium' ? 0.5 : 0.3;

          return (
            <View
              key={index}
              className={
                'size-1.5 shrink-0 rounded-full bg-white transition-[transform,opacity] duration-200 ease-out'
              }
              style={{ opacity, transform: [{ scale }] }}
              testID={`gallery-dot-${index}`}
            />
          );
        })}
      </View>
    </View>
  );
}

function getDotSize(index: number, startIndex: number, endIndex: number, count: number) {
  if (startIndex > 0) {
    if (index === startIndex) return 'small';
    if (index === startIndex + 1) return 'medium';
  }

  if (endIndex < count - 1) {
    if (index === endIndex) return 'small';
    if (index === endIndex - 1) return 'medium';
  }

  return 'large';
}
import { View } from 'react-native';
